// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__19Sv2","dragIcon":"SortableItem_dragIcon__3xsRy","disabled":"SortableItem_disabled__CsVPn"};